import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const RecorderThemeCtx = createContext({ dark: false, toggle: () => {} });

export function useRecorderTheme() {
  return useContext(RecorderThemeCtx);
}

export default function RecorderThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem('recorder-theme') === 'dark'; }
    catch { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem('recorder-theme', dark ? 'dark' : 'light'); }
    catch { /* noop */ }
  }, [dark]);

  const toggle = useCallback(() => setDark(d => !d), []);

  return (
    <RecorderThemeCtx.Provider value={{ dark, toggle }}>
      <div className={dark ? 'rec-theme-root rec-dark' : 'rec-theme-root rec-light'}>
        {children}
      </div>
    </RecorderThemeCtx.Provider>
  );
}
